import { Component, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { HttpClient } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ConfigurationService } from './configuration.service';
import { onboardingservice } from './pages/onboarding/onboarding.service';
import { JwtHelper } from 'angular2-jwt';
import { PWAService } from './progressivewebservice';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  private onDestroy$: Subject<void> = new Subject<void>();
  public settings: Settings;
  menu: any;
  loginData: any = {};
  agencyData: any = {};
  locationData: any = 0;
  menusitems: any = {};
  agencyList: any = {};
  agencydropdown: any = {};
  configuration:any;
  JwtHelper: JwtHelper = new JwtHelper();
  decodedToken:any;
  refreshData: any = {};
  appUserData:any={}
  constructor(public appSettings: AppSettings,public OnboardService: onboardingservice,public configurationservice: ConfigurationService, public toasterService: ToastrService, private router: Router, public global: GlobalComponent, private http: HttpClient,
    private ref: ChangeDetectorRef,  public serviceWorkers: PWAService) {
    this.settings = this.appSettings.settings;
    this.appUserData = JSON.parse(localStorage.getItem("fms_login"));
    this.configuration = this.configurationservice.getConfiguration();
    if (
      this.appUserData != null &&
      this.appUserData != undefined &&
      this.appUserData != ""
    ) {
      console.log("enters into app component")
      this.serviceWorkers.checkForUpdates();
    }
  }
  ngOnInit() {
    let onboardrole=localStorage.getItem("onboardLoginUser");
    let checkUrl=this.configuration.onboardingUrl +"#/employee-agreementlist/";
    this.global.deviceWidth = window.innerWidth;
    let appUserData = JSON.parse(localStorage.getItem("fms_login"));
    let fms_checkType = localStorage.getItem("fms_checkType")

    let agencyCode = localStorage.getItem("fms_agencyCode")
    if (agencyCode != null && agencyCode != undefined && agencyCode != '') {
      this.global.agencyCode = agencyCode;
    }
    if (fms_checkType != null) {
      this.global.OnboardingLoginType = fms_checkType;
    }
    if (this.global.OnboardingLoginType == "agencyLogin") {
      this.global.LoginUserType = 'Admin';
      if (appUserData != null) {
        this.global.authtoken = appUserData.accessToken;
        this.global.refreshTokenString = this.refreshData;

        this.decodedToken = this.JwtHelper.decodeToken(this.global.authtoken);
       
        this.global.globalAgencyId=this.decodedToken.AGENCYID
        this.global.refreshToken()
          .then(data => {
            this.global.scheduleRefresh();
            appUserData = JSON.parse(localStorage.getItem("fms_login"));
            this.refreshData = JSON.parse(localStorage.getItem("fms_refreshtoken "));
            this.global.assignToken(appUserData);
            this.getSideMenus();
            if ((this.global.selectedAgencyDropdown == null || this.global.selectedAgencyDropdown == undefined || this.global.selectedAgencyDropdown == '' )&& (this.decodedToken.AGENCYID ==null || this.decodedToken.AGENCYID ==undefined || this.decodedToken.AGENCYID =='' )) {
              this.global.globalAgencyId = "00000000-0000-0000-0000-000000000000";
              this.global.globalLocationList = [];
            }
            else if(this.global.loginusername!="SUPERADMIN")
            {
              this.global.getLocationforagencyuser();              
            }
            else{
              this.global.GetLocationDropDown();
            }
            this.global.getOverallAgencyDropDown();
          })
          .catch(err => {
            this.global.agencyLogo = null;
            this.global.agencyName = null;
            this.global.agencyPhone = null;
            this.global.globalAgencyId = '';
            this.global.globalLocationId = '';
            this.global.selectedLocationDropdown = '';
            this.global.ngLocationDropDown = [];
            this.global.userRoleDropDown = []
            this.global.userSelectedRole = ""
            this.global.globalAgencyDropdown = "";
            localStorage.clear();
            this.global.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
            this.router.navigateByUrl("/login"); 
          })
      }
    }
    else if (this.global.OnboardingLoginType == "onboardLogin") {
      this.global.LoginUserType = 'Onboard'  
      
      this.global.OnboardType= localStorage.getItem("onboardLoginUser")
      this.global.authtoken = appUserData.accessToken;
     
      this.global.OnboardingrefreshToken()
        .then(data => {
          this.global.OnboardingscheduleRefresh();
          appUserData = JSON.parse(localStorage.getItem("fms_login"));
          this.global.assignOnboardingToken(appUserData);
        })
        .catch(err => {
         
          this.global.agencyLogo = null;
          this.global.agencyName = null;
          this.global.agencyPhone = null;
          this.global.globalAgencyId = '';
          this.global.globalLocationId = '';
          this.global.selectedLocationDropdown = '';
          this.global.ngLocationDropDown = [];
          this.global.userRoleDropDown = []
          this.global.userSelectedRole = ""
          this.global.globalAgencyDropdown = "";
          this.global.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
        
          this.global.LogoutFunction(); 
          localStorage.clear();
        })
    }
   
    //..............................fms_sidebars///////////////////////////////////
    this.menusitems = localStorage.getItem("fms_sidebars");
    this.menusitems = JSON.parse(this.menusitems);
    ///..................................fms_agencydetails........................................
    this.agencyList = JSON.parse(localStorage.getItem("fms_agencydetails"));
    //......................................fms_agencyNames........................................
    this.agencydropdown = JSON.parse(localStorage.getItem("fms_agencyNames"));
    //...................................fms_login.................................................
    let onboardagencycode = localStorage.getItem("fms_onboardagencycode")
    this.loginData = localStorage.getItem("fms_login");
    this.loginData = JSON.parse(this.loginData);
    this.agencyData = JSON.parse(localStorage.getItem("fms_globalagencydetails"));
    if (this.global.OnboardingLoginType == "agencyLogin") {
      if (this.loginData != null) {
        this.global.assignToken(this.loginData);
        //fms_agencydetails
        if (this.agencyList != null) {
          this.global.getAgencyDetails(this.agencyList)
        }
        //Menu_items//
        if (this.menusitems != null) {
          this.global.AddMenuItems(this.menusitems)
        }
        //agencyData//
        if (this.agencyData != null) {
          this.global.Addagencydata(this.agencyData);
          this.global.globalAgencyDropdown = this.agencyData.agencyId;
          this.global.selectedAgencyDropdown = this.agencyData.agencyId;
          this.global.selectAgencyCode=this.agencyData.agencyCode
        }
        //agencydropdown
        if (this.agencydropdown != null) {
          this.global.AddAgencyDropdown(this.agencydropdown);
        }
        //locationId
        this.locationData = JSON.parse(localStorage.getItem("fms_location"));
        if (this.global.selectedLocationDropdown != null) {
          this.global.selectedLocationDropdown = this.locationData;
         
        }
        else {
          this.global.selectedLocationDropdown = null;
        }
        this.router.navigateByUrl("/operational-dashboard");
      }
    }
    else if (this.global.OnboardingLoginType == "onboardLogin") {

      this.global.onboardingdetails(this.loginData);
      if (this.menusitems != null) {
        this.global.onboardsideMenus(this.menusitems)
      }
      this.global.fms_onboardagencycode = onboardagencycode;
    }
    else {
      let url = window.location.href;
    
      if (!(url.includes("onboarding/client") || url.includes("onboarding/employee"))) {
      
        this.router.navigateByUrl("/login");
      }
      else {
       
        let urlpath = url.split('#')
        this.router.navigateByUrl(urlpath[1]);

      }
    }
    if (this.global.OnboardingLoginType == "onboardLogin") {
      
        if(onboardrole=="EMPLOYEE"){
        this.getEmployeeSideMenus();
        this.global.isClientOnboard==false
        }
      else{
        
        this.getClientSideMenus();
        this.global.isClientOnboard==true
      }
    
      
    }
  }
  scroll = (event: any): void => {

    this.ref.detach();
    setInterval(() => {
      this.ref.detectChanges();
    }, 10);

  };
  //........................................getSideMenus........................................................................
  getSideMenus() {
    var url = "api/Auth/GetSideMenus";
    this.http.get(url).subscribe((data: any) => {
      
      this.global.AddMenuItems(data);
      localStorage.setItem("fms_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }
  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }
  //............................... getuserDropDown...................................................
  getuserDropDown(id: string) {
    var url = "api/User/Getuserroledropdown?";
    let myParams = new URLSearchParams();
    myParams.append("userid", id);
    this.http.get(url + myParams).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.global.userRoleDropDown = data;
    });
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  getClientSideMenus() {
    this.OnboardService.getsideMenuforClientOnboarding().subscribe((data: any) => {
      this.setMenudata(data);
      localStorage.setItem("fms_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }
  // .................................getEmployeeSideMenus..........................................................
  getEmployeeSideMenus() {
    this.OnboardService.getsideMenuforEmployeeOnboarding().subscribe((data: any) => {
      this.setMenudata(data);
      localStorage.setItem("fms_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {

          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }
  // ................................setMenudata.......................................................................
  setMenudata(data) {
    let menu: any = []
    let i: number = 1;
    data.forEach(element => {
      let temp: any = {}
      temp.id = i;
      temp.title = element.title;
      temp.routerLink = element.routerLink;
      temp.href = null;
      temp.icon = element.icon;
      temp.target = null;
      temp.parentId = 0;
      if (element.children != null && element.children.length > 0) {
        let j: number = i + 1;
        element.children.forEach(element => {
          let submenu: any = {}
          submenu.id = j;
          submenu.title = element.title;
          submenu.routerLink = element.routerLink;
          submenu.href = null;
          submenu.icon = element.icon != undefined ? element.icon : null;
          submenu.target = null;
          submenu.hasSubMenu = false;
          submenu.parentId = i;
          menu.push(submenu);
          j++;
        });
        i = j - 1;
        temp.hasSubMenu = true;
      }
      else {
        temp.hasSubMenu = false;
      }
      menu.push(temp);
      i++;
    });
    this.global.sideMenuItems = menu;
    localStorage.setItem("fms_menulist", JSON.stringify(this.global.sideMenuItems));
    
  }
}





